<template>
  <v-dialog v-model="dialog" width="700px">
    <template v-slot:activator="{ on, attrs }">
      <div
        class="kt-header__topbar-item kt-header__topbar-item--search dropdown"
        id="kt_quick_search_toggle"
        v-bind="attrs"
        v-on="on"
      >
        <div class="kt-header__topbar-wrapper">
          <span class="kt-header__topbar-icon">
            <i class="fal fa-users-crown kt-svg-icon" id="search-icon"></i>
          </span>
        </div>
      </div>
    </template>
    <v-card>
      <v-card-text class="p-0">
        <div id="searchField" class="py-2 px-4">
          <v-text-field
            v-model="search"
            placeholder="Search user here"
            solo
            flat
            hide-details
            prepend-icon="fa-search"
            ref="searchInput"
            @keyup="handleSearch"
            :disabled="searchLoader"
          />
        </div>
        <v-divider class="mt-0" v-show="showResults" />
        <v-skeleton-loader
          class="mx-auto"
          max-width="77%"
          type="paragraph, sentences"
          v-show="searchLoader"
        />
        <div id="searchResult" class="px-4" v-show="showResults">
          <a
            href="javascript:"
            v-for="(user, index) in users"
            :key="index"
            class="resultLink text--darken-2 py-2 px-3"
            @click.prevent="switchUser(user)"
          >
            <span class="resultName">{{ user.name }}</span>
            <span class="resultCompany"> - {{ user.dealer.name }}</span>
            <span class="resultEmail"> - {{ user.email }}</span>
            <span class="float-right" style="color: #b9bab9">
              <i class="fad fa-sign-out ml-2" />
            </span>
          </a>
        </div>
      </v-card-text>
    </v-card>
    <confirm-user-switch
      :dialog="confirmUserSwitchDialog"
      :toggleConfirmDialog="toggleConfirmUserSwitchDialog"
      :user="user"
    />
  </v-dialog>
</template>

<script>
import { debounce as _debounce } from 'lodash-es';
import ConfirmUserSwitch from '@/components/partials/_header/ConfirmUserSwitch.vue';

export default {
  name: 'UserSwitcherDialog',
  components: { ConfirmUserSwitch },
  data() {
    return {
      dialog: false,
      search: '',
      users: [],
      scrollbar: {
        maxScrollbarLength: 60,
      },
      searchLoader: false,
      confirmUserSwitchDialog: false,
      user: {
        name: '',
      },
    };
  },
  computed: {
    showResults() {
      return this.users.length > 0 && !this.searchLoader;
    },
  },
  methods: {
    getSearchResult() {
      this.toggleSearchLoader();
      this.$http
        .post('/search/users', {
          search: this.search,
        })
        .then(({ data }) => {
          this.toggleSearchLoader();
          this.users = data;
        })
        .catch(() => {
          this.toggleSearchLoader();
        });
    },
    handleSearch: _debounce(function () {
      if (this.search === '') {
        return;
      }

      this.getSearchResult();
    }, 900),
    toggleSearchLoader() {
      this.searchLoader = !this.searchLoader;
    },
    toggleConfirmUserSwitchDialog() {
      this.confirmUserSwitchDialog = !this.confirmUserSwitchDialog;
    },
    switchUser(user) {
      this.user = user;
      this.toggleConfirmUserSwitchDialog();
    },
  },
  watch: {
    dialog(show) {
      if (show) {
        setTimeout(() => {
          this.$refs.searchInput.focus();
        }, 20);
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
#searchField .v-icon.v-icon
  font-size 25px!important

#searchField >>> input
  font-size 22px

.resultLink
  display block
  font-size 12px
  color #585858
  border-radius 5px

.resultName
  color #2b2b2b

.resultLink:hover
  background-color #e3e3e3
</style>
